import SearchManager from './search-manager'

const init = () => {
  const searchManager = new SearchManager()
}

init()
